import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromApp from '../store/app.reducer';
import { map, skipWhile, take } from 'rxjs';

export const adminGuardFn = () => {
  const router = inject(Router);
  const store = inject(Store<fromApp.AppState>);

  return store.select('auth').pipe(
    skipWhile((state) => !state.autoLoginAttempted),
    take(1),
    map((state) => {
      const isAdmin = state.user?.isStaff || state.user?.isSuperuser || state.user?.groups.includes('Admin');
      return isAdmin ? true : router.createUrlTree(['/map']);
    })
  );
};
